var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"leaflet-popup-header\">\n            "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\n            \u003C!--<i class=\"fa fa-user\"></i>&nbsp;&nbsp;"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "-->\n        </div>\n        <div class=\"leaflet-popup-profile\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"email") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":12},"end":{"line":12,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"mobileNumber") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":12},"end":{"line":17,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"phoneNumber") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":12},"end":{"line":22,"column":19}}})) != null ? stack1 : "")
    + "        </div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <span class=\"leaflet-popup-address-title\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.Email",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":9,"column":58},"end":{"line":9,"column":81}}}))
    + ":</span>\n                <span class=\"leaflet-popup-address-text\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"email") : depth0), depth0))
    + "</span>\n                </br>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <span class=\"leaflet-popup-address-title\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.Cellphone",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":14,"column":58},"end":{"line":14,"column":85}}}))
    + ":</span>\n                <span class=\"leaflet-popup-address-text\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"mobileNumber") : depth0), depth0))
    + "</span>\n                </br>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <span class=\"leaflet-popup-address-title\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.Phone",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":19,"column":58},"end":{"line":19,"column":81}}}))
    + ":</span>\n                <span class=\"leaflet-popup-address-text\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"phoneNumber") : depth0), depth0))
    + "</span>\n                </br>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;

  return "        <div class=\"leaflet-popup-header\">\n            "
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.Unknown",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":26,"column":12},"end":{"line":26,"column":37}}}))
    + "\n        </div>\n        <div class=\"leaflet-popup-profile\">\n            <span class=\"leaflet-popup-address-text\">"
    + alias2(__default(require("./i18n.js")).call(alias1,"Error.DataUnavailable",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":29,"column":53},"end":{"line":29,"column":85}}}))
    + "</span>\n        </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"leaflet-popup-body\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":31,"column":11}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/map-layer-clients-popup.hbs
// module id = B2+/
// module chunks = 1